import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import { CustomButton, CustomReactSelect } from '../../../shared';
import { Trash, DownloadIcon, Upload } from '../../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import { fileUploadActions } from '../../../../redux/reducers/filesUploadReducer';
import { downloadFiles } from '../../../../utility';
import {
    deleteFiles,
    getFiles,
} from '../../../../redux/thunks/filesUploadThunk';
import ConfirmationDelete from '../confirmationDelete';
import { toast } from 'react-toastify';

const FilterBar = (props) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const { companyOptions, company: selectedCompany } = useSelector(
        (state) => state.company
    );
    const { files, selectedFiles } = useSelector((state) => state.filesUpload);
    const { setCompany } = companyActions;

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };

    const handleDownload = () => {
        if (!selectedFiles.length) {
            toast.error('Please select at least one file to download!!');
        } else {
            const filesToDownload = selectedFiles
                .map((id) => {
                    const fileDetails = files.find((file) => file.id === id);
                    return fileDetails
                        ? {
                              file_url: fileDetails.file_url,
                              file_name: fileDetails.file_name,
                          }
                        : null;
                })
                .filter((file) => file);

            downloadFiles(filesToDownload);
            dispatch(fileUploadActions.handleSelected({ type: 'unselect' }));
        }
    };

    const handleDeleteOpen = () => {
        console.log(selectedFiles);
        if (!selectedFiles.length)
            toast.error('Please select at least one file to delete!!');
        else setOpen(true);
    };
    const handleDeleteSelected = () => {
        if (selectedFiles.length > 0) {
            dispatch(
                deleteFiles({
                    companyId: selectedCompany.id,
                    data: { ids: selectedFiles },
                })
            ).then((result) => {
                if (result.payload.status_code === 200) {
                    dispatch(fileUploadActions.setSelectedAllFalse());
                    dispatch(
                        fileUploadActions.handleSelected({ type: 'unselect' })
                    );
                    dispatch(getFiles({ companyId: selectedCompany.id }));
                    onclose();
                }
            });
        }
    };

    const onclose = () => {
        setOpen(!open);
    };

    return (
        <>
            <Grid className="flex-row-space-between pb-24px mt-10px">
                <Grid className="d-flex gap-12" xs={6}>
                    {/* Select Inputs */}
                    <Box className="flex-row gap-12">
                        <Box width={300}>
                            <CustomReactSelect
                                options={companyOptions}
                                handleFilter={handleCompanyChange}
                                selectedOption={{
                                    label: selectedCompany.name,
                                    value: selectedCompany.id,
                                }}
                                customStyle={{ borderRadius: '50px' }}
                                placeholder="Select Company"
                            />
                        </Box>
                    </Box>
                </Grid>
                <Grid xs={6} className="d-flex gap-12">
                    <CustomButton
                        title="Upload File"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        icon={<Upload color="#FFFFFF" />}
                        handleClick={() =>
                            dispatch(fileUploadActions.handleUploadModal())
                        }
                    />
                    <CustomButton
                        title="Download Files"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        icon={<DownloadIcon color="#FFFFFF" />}
                        handleClick={handleDownload}
                    />
                    <CustomButton
                        title="Delete Files"
                        icon={<Trash />}
                        handleClick={() => handleDeleteOpen()}
                    />
                </Grid>
            </Grid>
            <ConfirmationDelete
                open={open}
                onClosed={onclose}
                onConfirms={handleDeleteSelected}
            />
        </>
    );
};

export default FilterBar;
